import { styled } from 'styled-components';

import React, { useEffect } from 'react';

const Div = styled.div`
    display: block;
    position: fixed;
    top: 20px;
    right: 20px;
    background-color: red;
    z-index: 9999;
    padding: 20px 50px 20px 50px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    border-radius: 0px 0px 12px 12px;
    background: var(--lighten-darken-light-white, #fff);
    flex-shrink: 0;
    box-shadow: 0px 11px 43px 0px rgba(62, 62, 74, 0.12);
    .message {
        margin-left: 20px;
        font-family: Poppins;
        font-size: 18px;
        font-weight: 700;
        color: ${(props) => props.theme.tertiaryFontColor};
    }
    ,
    .notification {
        border-top: 3px solid ${(props) => props.theme.colorGreen};
    }
    .sentMessage {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;
const Notification = ({ message, name, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 3000); // Adjust duration as needed (in milliseconds)

        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <Div className="notification">
            <div className="sentMessage">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM10 14.17L16.59 7.58002L18 9.00002L10 17L6 13L7.41 11.59L10 14.17Z"
                        fill="#75BD2F"
                    />
                </svg>
                <span className="message">{message}</span>
            </div>

            <span> To {name} </span>
        </Div>
    );
};

export default Notification;
